import { type FC } from "react";

export type SafeAreaBottomProps = object;

/**
 * 检测设备是否有 Home Indicator
 * 适用于检测 iPhone X 及以后的全面屏机型，以及 iPad Pro 2018 及以后的机型
 * @returns {boolean} 是否有 Home Indicator
 */
function hasHomeIndicator() {
    // 不是 iOS 设备直接返回 false
    // @ts-ignore
    if (!(/iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream)) {
        return false;
    }

    // 检测 iOS/iPadOS 13+ 的 iPad Pro
    // 注意：从 iPadOS 13 开始，iPad 的 navigator.platform 会返回 "MacIntel"
    if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
        return true;
    }

    const screenHeight = window.screen.height;
    const screenWidth = window.screen.width;
    // 获取实际的设备高度和宽度中的较大值
    const dimension = Math.max(screenHeight, screenWidth);

    if (/iPhone/.test(navigator.userAgent)) {
        // iPhone X 和后续机型的设备分辨率特征
        // iPhone X/XS/11 Pro: 1125 x 2436
        // iPhone XR/11: 828 x 1792
        // iPhone XS Max/11 Pro Max: 1242 x 2688
        // iPhone 12 mini: 1080 x 2340
        // iPhone 12/12 Pro: 1170 x 2532
        // iPhone 12 Pro Max: 1284 x 2778
        return dimension >= 812;
    }

    if (/iPad/.test(navigator.userAgent)) {
        // iPad Pro 2018 及后续带有 Home Indicator 的机型
        // 11-inch iPad Pro: 834 x 2388
        // 12.9-inch iPad Pro: 1024 x 2732
        return dimension >= 1024 && window.devicePixelRatio >= 2;
    }

    return false;
}

function getCSSVariable(
    variableName: string,
    element = document.documentElement
) {
    // 获取原始值（可能带有单位，如 "34px"）
    const value = getComputedStyle(element)
        .getPropertyValue(variableName)
        .trim();

    // 如果需要数值计算，可以转换为数字
    const numericValue = parseFloat(value);

    return {
        rawValue: value, // 原始值（带单位）
        numericValue: numericValue, // 数值
    };
}

export const isWebA = () => {
    try {
        // @ts-ignore
        const result = Telegram.WebApp.platform === "weba";
        // console.log("PLATFORM IS WEBA ????", result);
        return result;
    } catch {
        return false;
    }
};

export const getSafeAreaInsetBottom = () => {
    return isWebA()
        ? "0px"
        : getCSSVariable("--tg-viewport-safe-area-inset-bottom")
                .numericValue === 0
          ? hasHomeIndicator()
              ? "12px"
              : "0px"
          : "var(--tg-viewport-safe-area-inset-bottom, 0px)";
};

export const SafeAreaBottom: FC<SafeAreaBottomProps> = () => {
    return (
        <div
            className="flex-none"
            style={{
                height: getSafeAreaInsetBottom(),
            }}
        />
    );
};

export default SafeAreaBottom;
